export const carouselDelayInMs = (timeoutInSeconds: number) => {
  return timeoutInSeconds ? timeoutInSeconds * 1000 : 3000
}
